import React from 'react';
import { motion } from 'framer-motion';
import ProductCard from '../components/ui/ProductCard';
import { products } from '../data/storeData';

export default function GiftGuide() {
  const giftIdeas = products.filter(p => p.isGiftIdea);

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      className="min-h-screen bg-cream py-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-navy rounded-sm overflow-hidden mb-16 flex flex-col md:flex-row relative">
          <div className="md:w-1/2 p-12 md:p-20 flex flex-col justify-center z-10 relative text-center md:text-left">
            <h4 className="font-sans text-xs tracking-[0.2em] uppercase text-brass mb-4">Curated Selection</h4>
            <h1 className="font-serif text-4xl md:text-5xl text-cream mb-6">The Gift Guide</h1>
            <p className="font-sans text-cream/80 max-w-md mx-auto md:mx-0">
              Give a gift that lasts a lifetime. We've hand-picked our favorite small goods and daily carries perfect for any occasion.
            </p>
          </div>
          <div className="md:w-1/2 relative h-64 md:h-auto">
            <img 
              src="https://images.unsplash.com/photo-1627123424574-724758594e93?auto=format&fit=crop&q=80" 
              alt="Gift Guide" 
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/50 to-transparent"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {giftIdeas.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </motion.div>
  );
}